import { NetworkProfileDetailSlideIn, NetworkProfileOverviewTab, NetworkProfilesPage } from '@infuse/e-connector/network-profile/pages';
import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';
import { networkProfilePermissions } from '@infuse/api/e-connector/network-profile';

export const NetworkProfileFeaturePlugin: Plugin = {
  install() {
    AppRouter.addRoute('main', {
      path: '/network-profiles',
      component: InfusePageView,
      meta: {
        name: 'nav.networkProfiles',
        icon: 'pools',
        group: 'nav.nav-group.manage',
        permissionIds: [networkProfilePermissions.SEARCH]
      },
      children: [
        {
          path: '',
          name: 'network-profiles',
          component: NetworkProfilesPage
        },
        {
          path: ':id',
          components: {
            default: NetworkProfilesPage,
            slideIn: NetworkProfileDetailSlideIn
          },
          children: [
            {
              path: '',
              redirect: {
                name: 'network-profiles.overview'
              }
            },
            {
              path: 'overview',
              name: 'network-profiles.overview',
              component: NetworkProfileOverviewTab,
              meta: {
                type: 'tab',
                label: 'tabs.networkProfiles.overview',
                permissionIds: [networkProfilePermissions.GET]
              }
            }
          ]
        }
      ]
    });
  }
};
